import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import moment from 'moment';
import DriverWageDetails from './driver-wage-details.jsx';

export default class DriverWageAccount extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      text: props.initialValue || 'placeholder',
      data: props.data || null,
      isLoading: true,
      viewJustOneDriver: props.viewJustOneDriver || null,
      currentMonthNumber: moment().month()+1,
      currentMonthYear: moment().year(),
      url: props.url || null,
    };

    this.setCurrentMonth.bind(this);
  }

  componentDidMount() {
    this.getDriverWageAccount();
    this.getDriverWagesForMonth(
      this.state.currentMonthNumber,
      this.state.currentMonthYear
    );
  }

  getDriverWageAccount() {
    if ((this.state.isLoading !== null)
      && (this.state.viewJustOneDriver !== null)) {
      return fetch(this.props.url, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer '+window.api_token
          ,"Accept": 'application/json'
        },
      }).
      then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          this.setState({
            data: driverJson,
            isLoading: false
          })
        });
      });
    }
    else {
      this.setState({isLoading: false});
    }
  }

  getDriverWagesForMonth(monthNumber, monthYear) {
    let that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/wage-accounts/'+
            this.state.data.driver_wage_account_id+'/get-wages-for/'+
            monthNumber+'/'+monthYear,
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(driverWagesJson) {
      that.setState({
        driver_wages: driverWagesJson,
        isLoading: false,
      });
    });
  }

  setCurrentMonth(monthNumber, monthYear) {
    this.getDriverWagesForMonth(monthNumber, monthYear);
    this.setState({
      currentMonthNumber: monthNumber,
      currentMonthYear: monthYear,
    });
  }

  handleButtonClicked(variable) {
    $("#driver-expanded-wages-list-"+variable).slideToggle(200);
    this.setState({expanded: !this.state.expanded})
  }

  handleWageDetailsButtonClicked(wage, title) {
    let driverName = this.state.data.first_name+' '+this.state.data.last_name;

    $('#driver-wage-details-modal').data('wage-id', wage.id);
    $('#driver-wage-details-modal').data('title', title);
    $('#driver-wage-details-modal').data('name', driverName);
    $('#driver-wage-details-modal').modal('show');

    if (document.getElementById(
      'react-component-g4-logistics-portal-driver-wage-details')) {
    $('#driver-wage-details-modal span.modal-title-driver-wage-details').html(title);
    $('#driver-wage-details-modal span.modal-title-driver-name').html(driverName);
      ReactDOM.unmountComponentAtNode(document.getElementById(
        'react-component-g4-logistics-portal-driver-wage-details'));
      ReactDOM.render(<DriverWageDetails data={wage} title={title} />,
        document.getElementById(
          'react-component-g4-logistics-portal-driver-wage-details'));
    }
  }

  render() {
    let currentMonthNumber = this.state.currentMonthNumber;
    let currentYear = this.state.currentMonthYear;

    let currentMonthName = moment(currentMonthNumber, 'MM').format('MMMM');

    let previousYear = currentYear - 1;
    let nextYear = currentYear + 1;
    let previousMonthYear = previousYear;
    let previousMonthNumber = currentMonthNumber - 1;
    let nextMonthNumber = currentMonthNumber + 1;
    let nextMonthYear = currentYear;

    if (currentMonthNumber > 1) {
      previousMonthNumber = currentMonthNumber - 1;
      previousMonthYear = currentYear;
    }
    else {
       previousMonthNumber = 12;
      previousMonthYear = previousYear;
    }

    if (currentMonthNumber < 12) {
      nextMonthNumber = currentMonthNumber + 1;
      nextMonthYear = currentYear;
    }
    else {
      nextMonthNumber = 1;
      nextMonthYear = nextYear;
    }


    let previousMonthName = moment(previousMonthNumber, 'MM').format('MMMM');
    let nextMonthName = moment(nextMonthNumber, 'MM').format('MMMM');
    let weekno1 = "Week 1";
    let weekno2 = "Week 2";
    let weekno3 = "Week 3";
    let weekno4 = "Week 4";
    if(this.state.driver_wages){
      weekno1 = (this.state.driver_wages[0].all_week_days[0]) ? moment(this.state.driver_wages[0].all_week_days[0].monday).format('DD-MM-Y'): weekno1;
      weekno2 = (this.state.driver_wages[0].all_week_days[1]) ? moment(this.state.driver_wages[0].all_week_days[1].monday).format('DD-MM-Y'): weekno2;
      weekno3 = (this.state.driver_wages[0].all_week_days[2]) ? moment(this.state.driver_wages[0].all_week_days[2].monday).format('DD-MM-Y'): weekno3;
      weekno4 = (this.state.driver_wages[0].all_week_days[3]) ? moment(this.state.driver_wages[0].all_week_days[3].monday).format('DD-MM-Y'): weekno4;
    }
    

    let titleForWeek1 = currentMonthName+' '+currentYear+' '+weekno1;
    let titleForWeek2 = currentMonthName+' '+currentYear+' '+weekno2;
    let titleForWeek3 = currentMonthName+' '+currentYear+' '+weekno3;
    let titleForWeek4 = currentMonthName+' '+currentYear+' '+weekno4;

    return(
      <div  
       id={"driver-wage-account-"+this.state.data.id}
      className={"driver-wage-account-container"+
      (this.state.expanded ? ' wage-container-expanded ' : '')}>

        <div
          className="row"
          onDoubleClick={
            (e) => {
              this.handleButtonClicked(this.state.data.id)
            }
          }
        >
          <div className="col-md-1 text-left">
            <img
              src={"/user-images/"+this.state.data.id}
              className="driver-excesses-table-driver-image"
            />
          </div>

          <div className="col-md-4">
            <h3>
              <a href={"/portal-admin/users/view/"+this.state.data.id}>
                {this.state.data.first_name} {this.state.data.last_name}
              </a>
            </h3>
          </div>

          <div className="col-md-5">
            <h3>
            #
            </h3>
          </div>

          <div className="col-md-2 text-right">
            <button
              onClick={(e) => {this.handleButtonClicked(this.state.data.id)}}
              className="btn btn-lg btn-default">
              Wages {(this.state.expanded ?
                <i className="fa fa-minus"></i>:
                <i className="fa fa-level-down-alt"></i>)}
            </button>
          </div>
        </div>


    {(this.state.driver_wages) ?
  <div
    className="driver-expanded-wages-list"
    id={"driver-expanded-wages-list-"+this.state.data.id}>
    <div className="row text-center">


        <div className="col-md-4">
          <a
            href="#"
            className="btn btn-lg btn-primary"
            onClick={(e) => {
              e.preventDefault();
              this.setCurrentMonth(
                previousMonthNumber,
                previousMonthYear
              )}
            }><i className="fas fa-arrow-left">
            </i> <i className="fas fa-calendar-alt">
            </i> {previousMonthName} {previousMonthYear}
          </a>
        </div>
        <div className="col-md-4">
          <a
            href=""
            onClick={(e) => {
              e.preventDefault();
            }}
            className="btn btn-lg btn-success">
            <i className="fas fa-calendar-alt">
            </i> {currentMonthName} {currentYear}
             </a>
        </div>
        <div className="col-md-4">
          <a
            href="#"
            className="btn btn-lg btn-primary"
            onClick={(e) => {
              e.preventDefault();
              this.setCurrentMonth(
                nextMonthNumber,
                nextMonthYear
              )}
            }>
            <i className="fas fa-calendar-alt">
          </i> {nextMonthName} {nextMonthYear} <i
          className="fas fa-arrow-right"></i>
          </a>
        </div>
        </div>

        <div className="row driver-wage-month-calendar-week-container">
          <div className="col-md-3 text-center">
            <div className={(this.state.driver_wages[0].wage_paid) ? 'wage-all-approved-and-paid-complete' :''}>
              <div className="row status-container">
                <div className="col-md-3 wage-amount-container">
                {
                  ((this.state.driver_wages[0].wage_total_payable_in_pence === 0) &&
                  (this.state.driver_wages[0].accountant_approved === 0)) ?
                    <i className="fa fa-question"></i>
                  :
                  <span>
                    &pound;{
                    (this.state.driver_wages[0].
                      wage_total_payable_in_pence/100).
                    toFixed(2)
                  }
                  </span>
                }
                </div>
                <div className="col-md-3 accountant-approved-container">
                {
                  (this.state.driver_wages[0].accountant_approved === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
                <div className="col-md-3 driver-approved-container">
                {
                  (this.state.driver_wages[0].driver_approved === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
                <div className="col-md-3 wage-paid-container">
                {
                  (this.state.driver_wages[0].wage_paid === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
              </div>
              <button className="btn btn-lg btn-dark"
                  onClick={() => {
                    this.handleWageDetailsButtonClicked(
                      this.state.driver_wages[0],
                      titleForWeek1
                    )
                  }}>
                <i className="fa fa-pound-sign"></i> Wage Details
              </button>
              <div className="week-title">
                {titleForWeek1}
              </div>
            </div>
          </div>
          <div className="col-md-3 text-center">
            <div className={(this.state.driver_wages[1].wage_paid) ? 'wage-all-approved-and-paid-complete' :''}>
              <div className="row status-container">
                <div className="col-md-3 wage-amount-container">
                {
                  ((this.state.driver_wages[1].wage_total_payable_in_pence === 0) &&
                  (this.state.driver_wages[1].accountant_approved === 0)) ?
                    <i className="fa fa-question"></i>
                  :
                  <span>
                    &pound;{
                    (this.state.driver_wages[1].
                      wage_total_payable_in_pence/100).
                    toFixed(2)
                  }
                  </span>
                }
                </div>
                <div className="col-md-3 accountant-approved-container">
                {
                  (this.state.driver_wages[1].accountant_approved === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
                <div className="col-md-3 driver-approved-container">
                {
                  (this.state.driver_wages[1].driver_approved === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
                <div className="col-md-3 wage-paid-container">
                {
                  (this.state.driver_wages[1].wage_paid === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
              </div>
              <button className="btn btn-lg btn-dark"
                  onClick={() => {
                  this.handleWageDetailsButtonClicked(
                    this.state.driver_wages[1],
                    titleForWeek2
                  )
                }}>
                <i className="fa fa-pound-sign"></i> Wage Details
              </button>
            <div className="week-title">
                {titleForWeek2}
            </div>
          </div>
          </div>
          <div className="col-md-3 text-center">
            <div className={(this.state.driver_wages[2].wage_paid) ? 'wage-all-approved-and-paid-complete' :''}>
              <div className="row status-container">
                <div className="col-md-3 wage-amount-container">
                {
                  ((this.state.driver_wages[2].wage_total_payable_in_pence === 0) &&
                  (this.state.driver_wages[2].accountant_approved === 0)) ?
                    <i className="fa fa-question"></i>
                  :
                  <span>
                    &pound;{(
                    (this.state.driver_wages[2].wage_total_payable_in_pence)
                  /100).toFixed()}
                  </span>
                }
                </div>
                <div className="col-md-3 accountant-approved-container">
                {
                  (this.state.driver_wages[2].accountant_approved === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
                <div className="col-md-3 driver-approved-container">
                {
                  (this.state.driver_wages[2].driver_approved === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
                <div className="col-md-3 wage-paid-container">
                {
                  (this.state.driver_wages[2].wage_paid === 0) ?
                    <i className="fa fa-times"></i>
                  :
                    <i className="fa fa-check"></i>
                }
                </div>
              </div>
              <button className="btn btn-lg btn-dark"
                  onClick={() => {
                    this.handleWageDetailsButtonClicked(
                      this.state.driver_wages[2],
                      titleForWeek3
                    )
                  }}>
                <i className="fa fa-pound-sign"></i> Wage Details
              </button>
              <div className="week-title">
                {titleForWeek3}
              </div>
            </div>
          </div>
          <div className="col-md-3 text-center">
            <div className={(this.state.driver_wages[3].wage_paid) ? 'wage-all-approved-and-paid-complete' :''}>
                <div className="row status-container">
                  <div className="col-md-3 wage-amount-container">
                  {
                    ((this.state.driver_wages[3].wage_total_payable_in_pence === 0) &&
                    (this.state.driver_wages[3].accountant_approved === 0)) ?
                      <i className="fa fa-question"></i>
                    :
                    <span>
                      &pound;{(
                        this.state.driver_wages[3].wage_total_payable_in_pence
                    / 100).toFixed(2)}
                    </span>
                  }
                  </div>
                  <div className="col-md-3 accountant-approved-container">
                  {
                    (this.state.driver_wages[3].accountant_approved === 0) ?
                      <i className="fa fa-times"></i>
                    :
                      <i className="fa fa-check"></i>
                  }
                  </div>
                  <div className="col-md-3 driver-approved-container">
                  {
                    (this.state.driver_wages[3].driver_approved === 0) ?
                      <i className="fa fa-times"></i>
                    :
                      <i className="fa fa-check"></i>
                  }
                  </div>
                  <div className="col-md-3 wage-paid-container">
                  {
                    (this.state.driver_wages[3].wage_paid === 0) ?
                      <i className="fa fa-times"></i>
                    :
                      <i className="fa fa-check"></i>
                  }
                  </div>
                </div>
              <button className="btn btn-lg btn-dark"
                  onClick={() => {
                    this.handleWageDetailsButtonClicked(
                      this.state.driver_wages[3],
                      titleForWeek4
                    )
                  }}
                  >
                <i className="fa fa-pound-sign"></i> Wage Details
              </button>
              <div className="week-title">
                {titleForWeek4}
              </div>
            </div>
            </div>
        </div>
          </div>: ''}
      </div>
    );
  }
}
